var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-rdh-c88": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M7 1.5L8.78016 5.21899L13 5.70156L9.88014 8.48196L10.7083 12.4994L7 10.499L3.29172 12.5L4.11986 8.48251L1 5.70101L5.22042 5.21844L7 1.5Z",
    stroke: "#013d50",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsicon);
export default __webpack_public_path__ + "static/media/assetsicon.dfc08c4ed4f90279b2c5607bf3106e2c.svg";
export { ForwardRef as ReactComponent };